module.exports = __webpack_public_path__ + "media/images/episode-067de5e8b21e90db4c4295e0e4641f1a.jpeg";